import React from "react";
import PropTypes from "prop-types";

export default function Item({
  quantity,
  id,
  destroy,
  serial_number: serialNumber,
  part: { part_number: partNumber, description },
  pushHistory,
  uuid
}) {
  const handleDelete = e => {
    e.stopPropagation();
    destroy(id);
  };

  const handleClick = e => {
    e.preventDefault();
    pushHistory(uuid);
  };

  return (
    <li className="cart-item">
      <a onClick={handleClick}>
        <table className="table" style={{ marginBottom: 0 }}>
          <tbody>
            <tr>
              <td>{partNumber}</td>
              <td className="text-right">QTY: {quantity}</td>
              <td className="td-shrink">
                <button
                  type="button"
                  className="close"
                  aria-label="Delete"
                  onClick={handleDelete}
                >
                  <span>
                    <i className="fa fa-close" />
                  </span>
                </button>
              </td>
            </tr>
            <tr>
              <td colSpan={3}>
                <em className="text-muted ">{serialNumber}</em>
                <br />
                <em className="text-muted">{description}</em>
              </td>
            </tr>
          </tbody>
        </table>
      </a>
    </li>
  );
}

Item.propTypes = {
  serial_number: PropTypes.string,
  id: PropTypes.number,
  quantity: PropTypes.number,
  part: PropTypes.shape({
    part_number: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }),
  destroy: PropTypes.func.isRequired,
  pushHistory: PropTypes.func.isRequired,
  uuid: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/Nav/RepairOrdersCart/Item.jsx